<template>
	<div class="th-back-top" v-show="flag" @click="clickHidden">
		<div class="bg-back2top2">
			<i class="iconfont icon-jiantou_xiangshang"></i>
		</div>
	</div>
</template>
<script>
	export default {
		name: "scrollTop",
		data() {
			return {
				flag: false,
			};
		},
		mounted() {
			//获取页面可视化高度
			window.addEventListener("scroll", () => {
				//获取页面滚动的高度
				let scrollTop = document.documentElement.scrollTop;
				if (scrollTop > 200) {
					this.flag = true;
				} else {
					this.flag = false;
				}
			});
		},
		methods: {
			clickHidden() {
				document.documentElement.scrollTop = 0; //点击返回顶部
			},
		},
	};
</script>
<style lang="less" scoped>
	.th-back-top {
		position: fixed;
		right: 20px;
		bottom: 120px;
		z-index: 9;
		opacity: 0.8;
		text-align: right;
	}
	.bg-back2top2 {
		background: #cccccc;
		width: 40px;
		height: 40px;
		text-align: center;
		cursor: pointer;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		.iconfont {
			font-size: 26px;
		}
	}
	.bg-back2top2:hover {
		background: #00598a;
	}

	@media screen and (max-width: 640px) {
		.bg-back2top2 {
			width: 35px;
			height: 35px;
			.iconfont {
				font-size: 22px;
			}
		}
	}
</style>
